module.exports = __webpack_public_path__ + "static/media/empty-polling-qr.60af61a7.svg";